import { autoinject, customAttribute } from 'aurelia-framework';
import { ToggleableAttribute } from 'framework/aurelia_tools/toggleable-attribute';
declare const $;

@autoinject
@customAttribute('bs-tooltip')
export class TooltipCustomAttribute extends ToggleableAttribute {
  constructor(private element: Element) {
    super();
  }

  protected enabled(): void {
    $(this.element).tooltip();
  }

  protected disabled(): void {
    $(this.element).tooltip('dispose');
  }

  show() {
    $(this.element).tooltip('show');
  }

  hide() {
    $(this.element).tooltip('hide');
  }

  update() {
    $(this.element).tooltip('update');
  }
}
